export default "__VITE_ASSET__D7D$hToK__"